'use strict';

const Backbone = require('backbone/backbone');

require('./IndexLoveDiscs.less');


module.exports = Backbone.View.extend({

    el: '.IndexLoveDiscs',

    events: {
        'mouseenter .IndexLoveDiscs-left-area': 'onLeftEnter',
        'mouseenter .IndexLoveDiscs-right-area': 'onRightEnter',
        'mousemove .IndexLoveDiscs-images-wrapper': 'onMouseMove'
    },

    initialize: function () {
        this.$wrapper = this.$('.IndexLoveDiscs-images-wrapper');
        this.$handle = this.$('.IndexLoveDiscs-handle');
        this.count = this.$('.IndexLoveDiscs-images').attr('data-count') - 0;
        this.$bottom = this.$('.IndexLoveDiscs-image-bottom');
        this.$top = this.$('.IndexLoveDiscs-image-top');
        this.switchSide = 1;
        this.curImage = 2;
        this.curtainPos = -1;
        this.updateCurtainPos();

        if (app.settings.isDesktop) {
            this.$('.IndexLoveDiscs-images').onCustom('screen-position', function (e, data) {
                if (data.screenPosition > 0.3) {
                    this.animateHandle(-1, 61, false, 500);
                    data.$el.offCustom('screen-position');
                }
            }.bind(this));
        }

        if (!app.settings.isDesktop) {
            app.utils.blockScrollOnSwipe(this.$('.IndexLoveDiscs-images')[0]);

            var initialX;
            var self = this;
            var currentX;

            var onTouchMove = function (e) {
                currentX = e.touches[0].clientX - initialX;
                var cw = self.$('.IndexLoveDiscs-images').width();
                var per;
                if (currentX > 0) {
                    per = -1 + 100 * currentX / cw;
                    self.switchSide = 1;
                } else {
                    per = 101 + 100 * currentX / cw;
                    self.switchSide = 0;
                }
                self.curtainPos = per;
                self.updateCurtainPos();
            };

            var onTouchEnd = function () {
                var per = self.curtainPos;
                var shift = Math.abs(currentX) > 40 ? 1 : 0;

                if (self.switchSide === shift) {
                    self.animateHandle(per, 101, !!shift, Math.abs(500 * (101 - per) / 101));
                } else {
                    self.animateHandle(per, -1, !!shift, Math.abs(500 * per / 101));
                }

                $('body')
                    .off('touchmove', onTouchMove)
                    .off('touchend', onTouchEnd);
            };

            this.$('.IndexLoveDiscs-images').on('touchstart', function (e) {
                if (self.animating) {
                    return;
                }

                initialX = e.touches[0].clientX;

                $('body')
                    .off('touchmove', onTouchMove)
                    .off('touchend', onTouchEnd)
                    .on('touchmove', onTouchMove)
                    .on('touchend', onTouchEnd);
            });
        }
    },



    animateHandle: function (from, to, switchToNext, duration) {
        if (this.animating) {
            return;
        }
        this.animating = true;

        var startTime = +new Date();
        var startVal = from;
        var endVal = to;
        var self = this;

        var animateProgress = function () {
            var curTime = +new Date();
            var per;
            var val;

            if (duration > 0) {
                per = Math.max(Math.min((curTime - startTime) / duration , 1), 0);
            } else {
                per = 1;
            }

            //val = Math.round(start_val + (end_val - start_val) * per);
            val = app.utils.easingFunctions(startVal, endVal, Math.pow(per, 0.5), 'linearTween');

            if (per === 1) {
                val = endVal;
            }

            self.curtainPos = val;
            self.updateCurtainPos();

            if (per < 1) {
                self.initialAnimationFrameId = window.requestAnimationFrame(animateProgress);
            } else {
                self.animating = false;
                switchToNext && self.setNextImage();
                switchToNext && (self.switchSide = 1 - self.switchSide);
                self.updateCurtainPos();
            }
        };

        animateProgress();
    },


    setNextImage: function () {
        this.curImage++;
        if (this.curImage > this.count) {
            this.curImage = 1;
        }

        this.$bottom.remove();

        this.$top.find('img').removeClass('lazy');

        var html = this.$top.html();

        this.$bottom = this.$top;

        this.$top = $('<div>').addClass('IndexLoveDiscs-image-top');
        this.$top.insertAfter(this.$bottom);

        html = html.replace(/\/(img\d+)/g, function () {
            return '/img' + this.curImage;
        }.bind(this));

        this.$top.html(html);
        this.$top.find('img')
            .attr('src', this.$top.find('img').attr('data-src'));
    },


    onMouseMove: function (e) {
        if (!app.settings.isDesktop) {
            return;
        }

        window.cancelAnimationFrame(this.initialAnimationFrameId);

        var x;
        var touches = e.changedTouches;

        if (touches) {
            x = touches[0].pageX - this.$wrapper.offset().left;
        } else {
            x = e.pageX - this.$wrapper.offset().left;
        }

        var w = this.$wrapper.width();
        this.curtainPos = 100 * x / w;

        this.updateCurtainPos();
    },

    onLeftEnter: function () {
        if (!app.settings.isDesktop) {
            return;
        }

        this.curtainPos = -1;
        this.updateCurtainPos();

        if (this.switchSide === 1) {
            return;
        }

        this.setNextImage();

        this.switchSide = 1 - this.switchSide;
        this.updateCurtainPos();
    },

    onRightEnter: function () {
        if (!app.settings.isDesktop) {
            return;
        }

        this.curtainPos = 101;
        this.updateCurtainPos();

        if (this.switchSide === 0) {
            return;
        }

        this.setNextImage();

        this.switchSide = 1 - this.switchSide;
        this.updateCurtainPos();
    },

    updateCurtainPos: function () {
        this.$handle.css('left', this.curtainPos + '%');

        if (this.switchSide === 0) {
            this.$top.css(
                '-webkit-clip-path',
                'polygon(' + this.curtainPos + '% 0%, 100% 0%, 100% 100%, ' + this.curtainPos + '% 100%)'
            );
            this.$top.css(
                'clip-path',
                'polygon(' + this.curtainPos + '% 0%, 100% 0%, 100% 100%, ' + this.curtainPos + '% 100%)'
            );
        }

        if (this.switchSide === 1) {
            this.$top.css(
                '-webkit-clip-path',
                'polygon(0% 0%, ' + this.curtainPos + '% 0%, ' + this.curtainPos + '% 100%, 0% 100%)'
            );
            this.$top.css(
                'clip-path',
                'polygon(0% 0%, ' + this.curtainPos + '% 0%, ' + this.curtainPos + '% 100%, 0% 100%)'
            );
        }
    }
});
